import React from 'react';
import PropTypes from 'prop-types';

import sharedStyles from '../../styles/shared';
import { responseOptionType } from '../../constants/types';
import { getTranslation } from '../../i18n';
import styles from './likertOptionsHeading.module.css';

const renderOption = (option, lang) => {
  const text = getTranslation(option.text, lang);
  const noMargin = { marginBottom: 0 };
  return (
    <div className={`${sharedStyles.option} ${sharedStyles.center}`} key={option.id}>
      <p style={noMargin}>{ text }</p>
    </div>
  );
};

const LikertOptionsHeading = (props) => (
  <div className={styles.stickyLegend} aria-hidden>
    <div className={sharedStyles.row}>
      <div className={sharedStyles.question} />
      { props.responseOptions.map((option) => renderOption(option, props.lang)) }
    </div>
  </div>
);

const { string, arrayOf } = PropTypes;

LikertOptionsHeading.propTypes = {
  lang: string.isRequired,
  responseOptions: arrayOf(responseOptionType).isRequired
};

export default LikertOptionsHeading;
